function AutoRefreshControls({ enabled, setEnabled, interval, setInterval, lastUpdated, intervalOptions }) {
  return (
    <div className="d-flex align-items-center gap-2 flex-wrap">
      <div className="form-check form-switch mb-0">
        <input
          className="form-check-input"
          type="checkbox"
          id="autoRefreshToggle"
          checked={enabled}
          onChange={(e) => setEnabled(e.target.checked)}
        />
        <label className="form-check-label small" htmlFor="autoRefreshToggle">
          Auto Refresh
        </label>
      </div>
      {enabled && (
        <select
          className="form-select form-select-sm"
          style={{ width: 'auto' }}
          value={interval}
          onChange={(e) => setInterval(Number(e.target.value))}
        >
          {intervalOptions.map((sec) => (
            <option key={sec} value={sec}>{sec}s</option>
          ))}
        </select>
      )}
      {lastUpdated && (
        <span className="text-muted small">
          Last: {lastUpdated.toLocaleTimeString()}
        </span>
      )}
    </div>
  );
}

export default AutoRefreshControls;
